import { Component } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';

import { CompanyService } from '../../services/company.service';

import { FaqTextListItem } from '../../models/company';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  private _handleError: HandleError;
  private _logging = environment.logging;

  // isBrowserIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  faqTextList: FaqTextListItem[] = [];
  faqsFound = false;

  constructor(
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _companyService: CompanyService,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('FaqComponent');
    this.getData();
    this.scrollToTop();
  }

  getData(): void {
    this.showSpinner = true;
    const companyCode: string = this._companyService.getCompanyCode();
    this.getFaqList(companyCode);
  }

  getFaqList(companyCode: string): void {
    this.showSpinner = true;
    this.faqsFound = false;
    this._companyService.getFaqList(companyCode).subscribe(
      resultArray => {
        this.faqsFound = resultArray.length > 0;
        this.faqTextList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('FaqComponent.getFaqList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('FaqComponent.getFaqList :: result = ' + JSON.stringify(resultArray));
        }
        this.getDataComplete();
      },
      error => this._handleError('getFaqList', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }

  scrollToTop() {
    const contentStart = document.getElementsByClassName('mat-sidenav-content');
    if (contentStart.length > 0) {
      contentStart[0].scrollTop = 0;
    }
  }
}
